import React, { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import colors from '../../../../../constants/colors';
import { axiosPath } from '../../../../../routing/helpers/router';
import axios from 'axios';
import AppLink from '../../../../../routing/helpers/AppLink';
import GoToMarker from './Elements/GoToMarker';
import Translator from '@/layout/components/helpers/Translator';
import NoInfo from '@/layout/components/helpers/NoInfo';
import * as currentPageAction from '../../../../../store/actions/currentPageAction';
import { useDispatch } from 'react-redux';
import useIsMounted from '@/layout/components/hooks/useIsMounted';

export default function NavBarLegalCompliancePlantSelect(props) {
  const { moduleBridgeHex, plantHex, filtersHex } = useParams();
  const dispatch = useDispatch();
  const isMounted = useIsMounted();
  const filterPermissions = useSelector(
    (state) =>
      state.module[moduleBridgeHex]?.permissions?.gcl?.module?.plant?.filters,
  );
  // const permissions = useSelector(
  //   (state) => state.module[moduleBridgeHex]?.permissions,
  // );
  const permissions = useSelector((state) => state.currentPage?.permissions);

  const userBridgePermissions = useSelector(
    (state) => state.module[moduleBridgeHex]?.userBridge,
  );
  const moduleJsonSettings = useSelector(
    (s) => s.module[moduleBridgeHex]?.jsonSettings,
  );
  const [navbarInfo, setNavbarInfo] = useState();

  // > GET NARVBAR INFO
  // const getNavbarInfo = useCallback(
  //   async () =>
  //     axios
  //       .post(
  //         axiosPath(
  //           'api_r_user_module_legalCompliance_plantSelect_getNavbarInfo',
  //         ),
  //         {
  //           moduleBridgeHex,
  //         },
  //       )
  //       .then((r) => {
  //         setNavbarInfo(r.data);
  //       }),
  //   [moduleBridgeHex],
  // );

  // useEffect(() => {
  //   getNavbarInfo();
  // }, []);
  // < GET NARVBAR INFO
  const loadModule = useCallback(async (mode) => {
    try {
      const response = await axios.post(
        axiosPath('api_r_user_module_legalCompliance_plantSelect_loadModule'),
        {
          moduleBridgeHex,
          mode,
        },
      );
      return response.data;
    } catch (err) {}
  }, []);

  useEffect(() => {
    loadModule('base').then((m) => {
      if (isMounted.current) {
        dispatch(currentPageAction.change('permissions', m?.permissions));
      }
    });
  }, [moduleBridgeHex]);


  return (
    <Container>
      {permissions?.gcl?.module?.userQuery &&
        permissions?.gcl?.module?.userQuery !== false && (
          <AppLink
            path="user_module_legalCompliance_userQuery_list"
            params={{
              moduleBridgeHex,
              plantHex: 1,
            }}
            className="btn btn-sm btn-info mr-2"
          >
            <Translator
              file="module-legalCompliance"
              name="m-gcl-view.queries"
            />
          </AppLink>
        )}
      <GoToMarker />
    </Container>
  );
}
const Container = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0 15px;
  color: white;
  li {
    display: inline-block;
    padding: 0 6px;
  }
  li + li {
    border-left: 2px solid ${colors.primaryLight};
  }
  li.off {
    opacity: 0.2;
  }
`;
